module.exports = __webpack_public_path__ + "static/media/cloudy-3-day.5d253a3e.svg";